import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Marca } from '../interfaces/marca';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: "root",
})
export class MarcaService {
  readonly path = "/marca";

  constructor(
    private http: HttpClient,
    public jwtAuthService: JwtAuthService
  ) {}

  create(): Observable<Marca> {
    return this.http.post<Marca>(`${this.jwtAuthService.apiUrl + this.path}`,null);
  }

  saveOrUpdate(cadastro: Marca): Observable<Marca> {
    return this.http.put<Marca>(
      `${this.jwtAuthService.apiUrl + this.path}`,
      cadastro
    );
  }

  getMarca(id: number): Observable<Marca> {
    return this.http.get<Marca>(
      `${this.jwtAuthService.apiUrl + this.path}/${id}`
    );
  }

  getMarcaPage(
    page?: number,
    size?: number,
    order?: string,
    direction?: string
  ): Observable<PageResult<Marca>> {
    const params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20))
      .set('order', order ?? 'NENHUM')
      .set('direction', direction ?? 'ASC');
    return this.http.get<PageResult<Marca>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/`, { params });
  }

  getMarcaPageSearch(
    page?: number,
    size?: number,
    search?: string,
    order?: string,
    direction?: string
  ): Observable<PageResult<Marca>> {
    let params = new HttpParams()
      .set('page', String(page ?? 1))
      .set('size', String(size ?? 20))
      .set('order', order ?? 'NENHUM')
      .set('direction', direction ?? 'ASC');
    if (search != null && String(search).trim() !== '') {
      params = params.set('search', String(search).trim());
    }
    return this.http.get<PageResult<Marca>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/`, { params });
  }

  doesCodeExist(code: any, uuid: string) {
    return this.http.get<boolean>(
      `${this.jwtAuthService.apiUrl + this.path}/${code}?uuid=${uuid}`
    );
  }
}
